export default function DeafBlindIcon({
  stroke = "#626060",
  fill = "#626060",
}: {
  stroke?: string;
  fill?: string;
}) {
  return (
    <svg
      width="57"
      height="32"
      viewBox="0 0 57 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.986 19.6713C22.2865 18.1362 24 15.7712 24 12.8571C24 10.7733 23.1571 8.7748 21.6569 7.3013C20.1566 5.8278 18.1217 5 16 5C13.8783 5 11.8434 5.8278 10.3431 7.3013C8.84285 8.7748 8 10.7733 8 12.8571V23.0012C8 25.1747 9.787 27 12 27C14.213 27 15.3415 25.7262 15.8645 25.0357C16.603 24.0629 17.95 21.0305 19.986 19.6713Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 18V12.2308C11 9.90385 13.25 8 16 8C18.75 8 21 9.90385 21 12.2308"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 14.8123C12.341 13.8496 15.2815 14.01 15.2815 14.01C16.6761 14.01 17.4899 15.5835 16.6761 16.7162C16.6761 16.7162 14.699 18.9838 14.4308 20"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31 9.34056L32.28 8L49 25.6489L47.73 27L44.65 23.7489C43.5 24.15 42.28 24.3611 41 24.3611C36 24.3611 31.73 21.0783 30 16.4444C30.69 14.5867 31.79 12.9506 33.19 11.6522L31 9.34056ZM41 13.2778C41.7956 13.2778 42.5587 13.6114 43.1213 14.2053C43.6839 14.7991 44 15.6046 44 16.4444C44.0005 16.8039 43.943 17.1609 43.83 17.5L40 13.4572C40.3213 13.3379 40.6594 13.2772 41 13.2778ZM41 8.52778C46 8.52778 50.27 11.8106 52 16.4444C51.1834 18.6325 49.7966 20.5319 48 21.9228L46.58 20.4133C47.9629 19.4036 49.0783 18.0374 49.82 16.4444C49.0117 14.7026 47.7565 13.2352 46.1974 12.2089C44.6382 11.1826 42.8375 10.6386 41 10.6389C39.91 10.6389 38.84 10.8289 37.84 11.1667L36.3 9.55167C37.74 8.89722 39.33 8.52778 41 8.52778ZM32.18 16.4444C32.9883 18.1863 34.2435 19.6537 35.8026 20.68C37.3618 21.7063 39.1625 22.2503 41 22.25C41.69 22.25 42.37 22.1761 43 22.0283L40.72 19.6111C40.0242 19.5324 39.3748 19.2046 38.88 18.6823C38.3851 18.1599 38.0746 17.4745 38 16.74L34.6 13.1406C33.61 14.0378 32.78 15.1567 32.18 16.4444Z"
        fill={fill}
      />
    </svg>
  );
}
